export const CHANGE_BALANCE = "CHANGE_BALANCE";
export const CHANGE_ACCOUNT = "CHANGE_ACCOUNT";

export const changeBalance = (totalAccounts,selectedAccounts) => (dispatch) => {
  const balance = totalAccounts ? totalAccounts.balance : null;
  const selectedBalance = selectedAccounts ? selectedAccounts.balance : null;
  dispatch({
    type: CHANGE_BALANCE,
    totalAccounts: balance,
    selectedAccount: selectedBalance,
  });
};
export const changeAccount = (selectedAccountWallet) => (dispatch) => {
  const balance = selectedAccountWallet ? selectedAccountWallet.balance : null;
  const selectedName = selectedAccountWallet
    ? selectedAccountWallet.name
    : "Account";
  dispatch({
    type: CHANGE_ACCOUNT,
    selectedAddress: selectedAccountWallet
      ? selectedAccountWallet.address.toString()
      : null,
    selectedAccount: balance,
    selectedAccountName: selectedName,
  });
};
